export default class DateUtils {

    static convertBRDateToIsoString(date: string): any {
        let [d, m, y] = date.split(/\D/);
        return new Date(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10)).toISOString();
    }

    static parseBrazilianDate(s: string | null | undefined) {
        if (!s || s.length < 10) {
            return undefined
        }

        s = s.trim()
        if (s.length < 10) {
            return undefined
        }

        if (s.charAt(2) !== '/' || s.charAt(5) !== '/') {
            return undefined
        }
        const dd = Number.parseInt(s.substring(0, 2))
        const mm = Number.parseInt(s.substring(3, 5))
        const yyyy = Number.parseInt(s.substring(6, 10))
        if (Number.isNaN(dd) || Number.isNaN(mm) || Number.isNaN(yyyy)) {
            return undefined
        }
        return new Date(yyyy, mm - 1, dd)
    }

    static formatBrazilianDate(dt: Date | null | undefined) {
        if (!dt) {
            return ''
        }

        const dd = `${dt.getDate()}`.padStart(2, '0')
        const mm = `${dt.getMonth() + 1}`.padStart(2, '0')
        const yyyy = `${dt.getFullYear()}`.padStart(4, '0')
        return `${dd}/${mm}/${yyyy}`
    }

    static parseIsoDate(s: string | null | undefined) {
        if (!s || s.length < 10) {
            return undefined
        }

        s = s.trim()
        if (s.length < 10) {
            return undefined
        }

        if (s.charAt(4) !== '-' || s.charAt(7) !== '-') {
            return undefined
        }
        const yyyy = Number.parseInt(s.substring(0, 4))
        const mm = Number.parseInt(s.substring(5, 7))
        const dd = Number.parseInt(s.substring(8, 10))
        if (Number.isNaN(dd) || Number.isNaN(mm) || Number.isNaN(yyyy)) {
            return undefined
        }
        return new Date(yyyy, mm - 1, dd)
    }
}